module.exports = __webpack_public_path__ + "img/tum_logo.b113dd72.svg";